import type { PlaeeOrderBookEntryDto } from '@/lib/models';

/** One rendered book level: the raw entry plus running depth away from the spread. */
export interface DepthLevel extends PlaeeOrderBookEntryDto {
  /** Shares resting at this level and every level between it and the spread. */
  cumulativeQuantity: number;
  /** Notional cost (price × shares, summed) to sweep the book through this level. */
  cumulativeTotal: number;
}

/**
 * Accumulate depth away from the spread. Levels must arrive best-first (the
 * order both the snapshot and the live overlay emit): each level gains the
 * running share depth and the notional cost to fill through it — the standard
 * order-book "Total" semantics (cf. Polymarket), where the column answers
 * "what does it cost to take every order up to and including this level?".
 */
export function accumulateDepth(levels: PlaeeOrderBookEntryDto[]): DepthLevel[] {
  let quantity = 0;
  let total = 0;
  return levels.map((level) => {
    quantity += level.quantity ?? 0;
    total += (level.price ?? 0) * (level.quantity ?? 0);
    return { ...level, cumulativeQuantity: quantity, cumulativeTotal: total };
  });
}
